import React from "react";
import UserMasterLayout from "../../../Layouts/UserMasterLayout/UserMasterLayout";
import NotificationStyles from "../../../components/Customer/notfication/NotificationStyles";
const UserNotification =()=>{
    return(
  <UserMasterLayout>
    <NotificationStyles/>
  </UserMasterLayout>
    );
}
export default UserNotification;